// Pixel Meta (Facebook) — chargé uniquement si REACT_APP_META_PIXEL_ID est défini.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let ready = false;

export function initMetaPixel() {
  if (!PIXEL_ID || ready || typeof window === "undefined") return;
  if (!window.fbq) {
    const n = (window.fbq = function (...args) {
      n.queue.push(args);
    });
    n.queue = [];
    n.loaded = true;
    n.version = "2.0";
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  }
  window.fbq("init", PIXEL_ID);
  ready = true;
}

export function trackPageView() {
  if (ready && window.fbq) window.fbq("track", "PageView");
}

export function trackMetaEvent(name, params) {
  if (ready && window.fbq) window.fbq("track", name, params || {});
}
